exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-7d39b904]{border-collapse:unset}table th[data-v-7d39b904]:first-child{border-top-left-radius:6.79px;border-left:1px solid #ed1763!important}table th[data-v-7d39b904]:last-child{border-top-right-radius:6.79px;border-right:1px solid #ed1763!important}.table-cart thead th[data-v-7d39b904]{border-top:1px solid #ed1763!important;border-bottom:1px solid #ed1763!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d39b904","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/TableItems.vue
// module id = Hfwr
// module chunks = 102